import app from "../app";
import FormStickyCTA from "../components/GatewayForm/FormStickyCTA";
import FormContextWrapper from "../components/GatewayForm/config/FormContextWrapper";

export const FactsheetStickyCTA = () => (
  <FormContextWrapper>
    <FormStickyCTA />
  </FormContextWrapper>
);

const FactsheetStickyCTAApp = app(FactsheetStickyCTA);
export default FactsheetStickyCTAApp;
